export const TempCodeLoginSenderKind = {
    phone: "phone",
    email: "email"
};
export const EXPIRE_TEMP_CODE_SEND_AGAIN_TIME_IN_SECONDS = 60;
